document.documentElement.classList.remove('no-js');

const initializeProductVariantPickers = (scope = document) => {
  scope.querySelectorAll('[data-product-section]:not([data-variant-picker-ready])').forEach((productSection) => {
    const variantData = productSection.querySelector('[data-product-variants]');
    const optionSelectors = [...productSection.querySelectorAll('[data-product-option]')];
    const variantIdInput = productSection.querySelector('[data-variant-id]');
    const currentPrice = productSection.querySelector('[data-product-price-current]');
    const comparePrice = productSection.querySelector('[data-product-price-compare]');
    const addButton = productSection.querySelector('[data-add-to-cart]');
    const status = productSection.querySelector('[data-variant-status]');
    const mainImage = productSection.querySelector('[data-product-main-image]');
    const thumbnails = [...productSection.querySelectorAll('[data-product-thumbnail]')];

    if (!variantData || !variantIdInput || !addButton) return;

    let variants;
    try {
      variants = JSON.parse(variantData.textContent);
    } catch (error) {
      productSection.setAttribute('data-variant-picker-error', 'invalid-product-data');
      return;
    }

    const showMedia = (mediaId, mediaUrl, mediaAlt) => {
      if (!mainImage || !mediaUrl) return;

      mainImage.src = mediaUrl;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      if (mediaAlt) mainImage.alt = mediaAlt;

      thumbnails.forEach((thumbnail) => {
        const isActive = String(thumbnail.dataset.mediaId) === String(mediaId);
        thumbnail.classList.toggle('is-active', isActive);
        thumbnail.setAttribute('aria-current', String(isActive));
      });
    };

    const handleize = (value = '') => String(value)
      .normalize('NFKD')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    const findColourThumbnail = () => {
      const colourSelector = optionSelectors.find((selector) => (
        ['colour', 'color'].includes(handleize(selector.dataset.optionName))
      ));
      if (!colourSelector) return null;

      const colourKey = handleize(colourSelector.value);
      if (!colourKey) return null;

      return thumbnails.find((thumbnail) => {
        let decodedUrl = thumbnail.dataset.mediaUrl || '';
        try {
          decodedUrl = decodeURIComponent(decodedUrl);
        } catch (error) {
          // Keep the original URL when it contains an incomplete escape sequence.
        }

        const filename = decodedUrl.split('/').pop().split('?')[0];
        const filenameKey = handleize(filename);
        const altKey = handleize(thumbnail.dataset.mediaAlt || '');
        return filenameKey.startsWith(`${colourKey}-`) || altKey.startsWith(`${colourKey}-`);
      }) || null;
    };

    const setUnavailable = () => {
      variantIdInput.value = '';
      addButton.disabled = true;
      addButton.textContent = 'Unavailable';
      if (status) {
        status.hidden = false;
        status.textContent = 'This option combination is unavailable.';
      }
    };

    const selectVariant = (variant, updateUrl = true, updateMedia = true) => {
      if (!variant) {
        setUnavailable();
        return;
      }

      variantIdInput.value = variant.id;
      productSection.dataset.selectedVariantId = variant.id;

      if (currentPrice) currentPrice.textContent = variant.price_formatted;
      if (comparePrice) {
        comparePrice.textContent = variant.compare_at_price_formatted || '';
        comparePrice.hidden = !variant.compare_at_price_formatted;
      }

      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? 'Add to basket' : 'Sold out';
      if (status) {
        status.hidden = variant.available;
        status.textContent = variant.available ? '' : 'This variant is currently sold out.';
      }

      if (updateMedia) {
        const colourThumbnail = findColourThumbnail();
        if (colourThumbnail) {
          showMedia(
            colourThumbnail.dataset.mediaId,
            colourThumbnail.dataset.mediaUrl,
            colourThumbnail.dataset.mediaAlt || variant.featured_media_alt
          );
        } else if (variant.featured_media_url) {
          showMedia(variant.featured_media_id, variant.featured_media_url, variant.featured_media_alt);
        }
      }

      if (updateUrl && window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      productSection.dispatchEvent(new CustomEvent('foamsupa:variant-change', {
        bubbles: true,
        detail: { variant }
      }));
    };

    const findSelectedVariant = () => {
      const selectedOptions = optionSelectors.map((selector) => selector.value);
      return variants.find((variant) => (
        variant.options.length === selectedOptions.length
        && variant.options.every((option, index) => option === selectedOptions[index])
      ));
    };

    optionSelectors.forEach((selector) => {
      selector.addEventListener('change', () => selectVariant(findSelectedVariant()));
    });

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        showMedia(thumbnail.dataset.mediaId, thumbnail.dataset.mediaUrl, thumbnail.dataset.mediaAlt);
      });
    });

    productSection.setAttribute('data-variant-picker-ready', 'true');
    const initialVariant = variants.find((variant) => String(variant.id) === String(variantIdInput.value));
    const urlHasSelectedVariant = new URL(window.location.href).searchParams.has('variant');
    selectVariant(initialVariant || findSelectedVariant(), false, urlHasSelectedVariant);
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');

  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
  }

  initializeProductVariantPickers();
});

document.addEventListener('shopify:section:load', (event) => {
  initializeProductVariantPickers(event.target);
});
